<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn_160">
      <el-select
        class="select_btn_style"
        v-model="filters.auditStatus"
        placeholder="审核状态"
      >
        <el-option
          v-for="(item, i) in auditStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.leaveType"
        placeholder="请假类型"
      >
        <el-option
          v-for="(item, i) in leaveTypeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.nameOrNotes"
        placeholder="学员姓名/申请事由"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      auditStatusList: [],
      leaveTypeList: [],
    };
  },
  created() {
    this.getSysParamByTypes(["AUDIT_STATUS", "LEAVE_TYPE"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["AUDIT_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["LEAVE_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.auditStatusList = res.data["AUDIT_STATUS"] || [];
        this.leaveTypeList = res.data["LEAVE_TYPE"] || [];
      });
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
